<template>
    <div>
        <h6>Add Coupon</h6>
        <form class="promocode-input" action="#" method="post">
            <input type="text" placeholder="Enter Promo Code" class="form-control" v-model="promoCode">
            <button type="submit" @click.prevent="submitPromoCode">Apply</button>
        </form>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import swalMessages from "../../../../../../resources/js/mixins/swal-messages";

    export default {
        name: "PromoCode",
        mixins: [ swalMessages ],
        data() {
            return {
                promoCode: null
            }
        },
        mounted() {
            this.promoCode = this.GET_CART_ORDER ? this.GET_CART_ORDER.promo.name : null
        },
        computed: {
            ...mapGetters(['GET_CART_ORDER']),
        },
        methods: {
            ...mapActions({
                updateOrder: 'ACT_CART_ORDER'
            }),
            submitPromoCode() {
                if (this.promoCode) {
                    axios.post('/promo-code', { code: this.promoCode })
                        .then(response => {
                            const { name, error } = response.data.order.promo;

                            if (name !== null) {
                                this.showSuccessMessage('Your promo code was successfully submitted');
                            } else {
                                if (error !== null){
                                    this.showErrorMessage(error);
                                } else {
                                    this.showErrorMessage('You have entered the wrong code');
                                }
                            }

                            this.updateOrder(response.data.order);
                        })
                        .catch(error => {
                            console.log(error)
                        });
                }
            }
        }
    }
</script>
